import { useCallback, useEffect, useState } from 'react';
import { usePlayerContext } from '../PlayerContext';
import { useStore } from '../hooks/useStore';
import { formatTime } from './formatTime';
import styles from './TimeDisplay.module.css';

export function TimeDisplay() {
  const { store, eventBus } = usePlayerContext();
  const currentTime = useStore(store, useCallback(s => s.currentTime, []));
  const duration = useStore(store, useCallback(s => s.duration, []));
  const [pendingSeek, setPendingSeek] = useState<number | null>(null);

  // Show the seek target immediately; hold it until playback catches up
  useEffect(() => {
    return eventBus.on('seek:to', (time: number) => setPendingSeek(time));
  }, [eventBus]);

  useEffect(() => {
    if (pendingSeek === null) return;
    if (Math.abs(currentTime - pendingSeek) <= 0.75) {
      setPendingSeek(null);
    }
  }, [currentTime, pendingSeek]);

  const displayTime = pendingSeek ?? currentTime;

  return (
    <span className={styles.timeDisplay} data-testid="time-display">
      {formatTime(displayTime)} / {formatTime(duration)}
    </span>
  );
}
